import { useState } from 'react'

import { PROGRAMS } from '@/constants/search/federal/sbir'

import { useLocalSearch } from '@/hooks/search/useLocalSearch'

export const useSbirProgramSearch = () => {
  const [query, setQuery] = useState<string>('')

  const { results: searchedItems } = useLocalSearch(query, PROGRAMS)

  return {
    data: searchedItems.map((item) => item.item),
    query,
    setQuery,
  }
}
